let development = "https://m.newbuiltholdings.com.cn/api";   //测试机
let production = "/api";   //测试机

export default {
    baseURL: process.env.NODE_ENV === 'production' ? production : development,
    timemout: 30,
    headers: {},
    ImgUrlPath: development + "avatar/img?id="
};
